<div class="flex flex-wrap">

  <mat-card class="m-32" [ngClass]="{
        'bg-gray-200': settings.theme === 'light'
      }">
    <mat-card-title class="f-s-30 m-x-24 m-t-24" style="color: #005595">
      <h1>OREGON ENVIRONMENTAL LABORATORY ACCREDITATION PROGRAM</h1>
    </mat-card-title>
    <mat-card-content class="f-s-20 m-x-24 m-b-24">The Oregon Environmental Laboratory Accreditation Program (ORELAP) is
      recognized by The NELAC Institute’s
      National Environmental Laboratory Accreditation Program. ORELAP accredits qualified laboratories for testing under
      the Clean Air Act (CAA),
      Clean Water Act (CWA), Resource Conservation and Recovery Act (RCRA), the Safe Drinking Water Act (SDWA) and other
      state and Federal regulations.</mat-card-content>
  </mat-card>

  <mat-card class="m-32" [ngClass]="{
    'bg-gray-200': settings.theme === 'light'
  }">
   <mat-card-content class="f-s-20 m-x-24 m-b-24">
    <mat-icon>domain</mat-icon> - This allows a user to login or register for a username.  Once you are logged in, you can view your accreditation profile and create and submit applications for your laboratory.  You can respond to assessment findings and view other information about your laboratory.<br/><br/>
    <mat-icon>search</mat-icon> - This allows you to search for an ORELAP accredited laboratory and view the scope of accreditation for any actively accredited laboratory.<br/><br/>
    <mat-icon>bubble_chart</mat-icon> - This allows you to search for an analyte and determine if it is offered as a field of accreditation by ORELAP.<br/><br/>
    <mat-icon>contact_mail</mat-icon> - This provides you information on how to get in contact with ORELAP staff if you have a question.
    </mat-card-content>
  </mat-card>

</div>